import React from "react";
import { useSidebar } from "@/components/ui/sidebar";
import { FeedbackButton } from "@/components/feedback/FeedbackButton";

export const SidebarLogo = () => {
  const { state } = useSidebar();
  
  return (
    <div className="flex items-center justify-between px-2 group-data-[collapsible=icon]:px-2">
      <div className="relative w-auto h-24 group-data-[collapsible=icon]:w-6 group-data-[collapsible=icon]:h-6 group-data-[collapsible=icon]:mb-3 transition-all duration-300 flex-shrink-0">
        {state === "collapsed" ? (
          <img
            src="/lovable-uploads/b395a010-3cbe-4756-9e56-02d87a12853b.png"
            alt="Logo"
            className="absolute inset-0 w-full h-full object-cover rounded-full"
          />
        ) : (
          <img
            src="/lovable-uploads/37508089-7804-4352-b3ba-8d85a9829bcb.png"
            alt="LinkPilot"
            className="h-full w-full object-contain"
          />
        )}
      </div>
      {state !== "collapsed" && <FeedbackButton />}
    </div>
  );
};